export default {
	search(params, cb, ecb) {
		this.http
			.get('/acl/role', { params })
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	update(form, cb, ecb) {
		this.http
			.post('/acl/role', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	remove(id, cb, ecb) {
		this.http
			.delete('/acl/role/' + id)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	rolesOfUser(userId, cb, ecb) {
		this.http
			.get(`/acl/user/${userId}/roles`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	setUserRoles(userId, roleIds, cb, ecb) {
		this.http
			.post(`/acl/user/${userId}/roles`, { role_ids: roleIds })
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	menusOfRole(roleId, cb, ecb) {
		this.http
			.get(`/acl/role/${roleId}/menus`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	setRoleMenus(roleId, menuKeys, cb, ecb) {
		this.http
			.post(`/acl/role/${roleId}/menus`, { menu_keys: menuKeys })
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	myMenus(cb, ecb) {
		this.http
			.get('/acl/me/menus')
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getRolesInDomain(domain, cb) {
		this.http
			.get(`/acl/getRolesInDomain/${domain}`, {})
			.then((response) => {
				cb(response)
			})
	},
	addUserRoleInDomain(form, cb, ecb) {
		this.http
			.post(`/acl/addUserRoleInDomain`, form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getRolesInDomainByUser(domain, domainId, userId, cb, ecb) {
		this.http
			.get(
				`/acl/getRolesInDomainByUser/${domain}/${domainId}/${userId ? userId : ''}`,
				{}
			)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getUserRoleInDomain(domain, domainId, cb, ecb) {
		this.http
			.get(`/acl/getUserRoleInDomain/${domain}/${domainId}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},

	getPermissions(roleid, cb) {
		this.http
			.get(`/acl/getPermissionsByRole/${roleid}`, {})
			.then((r) => cb && cb(r))
	},
	getRoleById(id, cb) {
		this.http.get(`/acl/getRoleById/${id}`, {}).then((response) => {
			cb(response)
		})
	},
	updateRole(form, cb, ecb) {
		this.http
			.post(`/acl/updateRole`, form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	removeRole(roleid, cb) {
		this.http.get(`/acl/removeRole/${roleid}`).then((r) => cb(r))
	},
	searchRole(params, cb, ecb) {
		this.http
			.post('/acl/searchRole', params)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	updateUserGroup(id, cb) {
		this.http.get('/user/removeAddress/' + id, {}).then((res) => {
			cb(res)
		})
	},
	getUserGroup(id, cb) {
		this.http.get(`/acl/getUserGroupById/${id}`, {}).then((res) => {
			cb(res)
		})
	},
	removeUserGroup(id, cb) {
		this.http.get('/user/setDefaultAddress/' + id, {}).then((res) => {
			cb(res)
		})
	},
	searchUserGroup(cb) {
		this.http.get('/user/getDefaultAddress/' + id, {}).then((res) => {
			cb(res)
		})
	},
	addUserRole(uid, rids, cb, ecb) {
		this.http
			.post(`/acl/addUserRole`, {
				user: uid,
				roles: rids
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	removeUserRoleById(id, cb) {
		this.http.get(`/acl/removeUserRoleById/${id}`, {}).then((r) => {
			cb(r)
		})
	},
	removeUserRole(uid, rid, cb) {
		this.http.get(`/acl/removeUserRole/${uid}/${rid}`, {}).then((r) => {
			cb(r)
		})
	},
	getRolesByUser(uid, cb) {
		this.http.get(`/acl/getRolesByUser/${uid}`, {}).then((r) => {
			cb(r)
		})
	}
}
